import React, { useState, useEffect } from "react";

import Navbar from "../components/Navbar";
import Sidebar2 from "../components2/Sidebar.js";
import verify from "../../../image/verify.png";

import { connect } from "react-redux";
import { gain } from "../../../store/acion";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { async } from "@firebase/util";
import { useLocation, useNavigate } from "react-router-dom";
import {
  doc,
  setDoc,
  getDocs,
  collection,
  getFirestore,
  updateDoc,
  documentId,

} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { deepPurple } from "@mui/material/colors";
import axios from "axios";
import { AiOutlineDisconnect } from "react-icons/ai";
import { BsShieldFillCheck, BsClock } from "react-icons/bs";
function ProfileTeacher(props) {
  const navigate = useNavigate();
  const [catg, setcatg] = React.useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [errorText, setErrorText] = useState('');
  const fetchTopics = async () => {
    try {
      const db = getFirestore();
      const topicsCollection = collection(db, "topics");
      const topicsSnapshot = await getDocs(topicsCollection);
      const topicsList = [];

      topicsSnapshot.forEach((doc) => {
        topicsList.push({
          id: doc.id,
          name: doc.data().name
        });
      });

      setAllTopics(topicsList);
    } catch (error) {
      console.error("Error fetching topics:", error);
    }
  };


  let [name, setName] = useState();
  let [address, setAddress] = useState("Local addredd");
  let [image, setImage] = useState(
    localStorage.getItem("user_profile") == "undefined" ||
      localStorage.getItem("user_profile") == undefined
      ? "http://i.pravatar.cc/500?img=7"
      : localStorage.getItem("user_profile")
  );
  let [zoom_status, setZoomStatus] = useState("");
  let [zoom_Error, setZoomError] = useState("");

  let [progress, setProgress] = useState("");
  let [error, setError] = useState("");
  let [nameValidate, setnameValidate] = useState("");
  let [emailValidate, setemailValidate] = useState("");
  let [file, setFile] = useState("");
  const [image3, setimage3] = useState("");
  const [zoom_conRes, setzoom_conRes] = useState("");
  const [zoom_conResErr, setzoom_conResErr] = useState("");

  let HideMeShowEdit = () => {
    document.getElementById("SeeME").style.display = "none";

    document.getElementById("EditME").style.display = "block";

    document.getElementById("hidingMeThis").style.display = "block";
  };

  let HideMeShowEdit1 = () => {
    document.getElementById("SeeME").style.display = "block";

    document.getElementById("EditME").style.display = "none";

    document.getElementById("hidingMeThis").style.display = "none";
  };

  let UpdateME = async () => {
    if (name == "") {
      setnameValidate("* Required");
      return;
    }

    HideMeShowEdit1();

    if (typeof image3 === "object") {
      const storage = getStorage();

      document.getElementById("imageResponsiveinput").style.opacity = 0.5;
      var key = Math.round(Math.random() * 33453452490);

      const uploadTask = uploadBytesResumable(
        ref(storage, `teachers dp/${image3.name}${key}`),
        image3
      );

      // var ref= firebase.storage().ref(`/`).child(`Dp/${file.name}+${key}`).put(file)
      uploadTask.on(
        "state_changed",
        function (snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //  localStorage.setItem('progress',progress)
          Math.round(progress);

          setProgress(Math.round(progress) + "%");

          switch (snapshot.state) {
            case "paused": // or 'paused'
              break;
            case "running": // or 'running'
              //  ('Upload is running');
              break;
          }
        },
        function (error) {
          // Handle unsuccessful uploads
          //  console.log(error);
        },
        () => {
          if (name) {
            getDownloadURL(uploadTask.snapshot.ref).then(async (pic) => {
              console.log("File available at", pic);

              const db = getFirestore();
              await updateDoc(doc(db, "teachers", request_data.uid), {
                name,
                pic,
              });

              setTimeout(() => {
                document.getElementById(
                  "imageResponsiveinput"
                ).style.opacity = 1;
              }, 500);
            });
          } else {
            getDownloadURL(uploadTask.snapshot.ref).then(async (pic) => {
              console.log("File available at", pic);

              const db = getFirestore();
              await updateDoc(doc(db, "teachers", request_data.uid), {
                pic,
              });

              setTimeout(() => {
                document.getElementById(
                  "imageResponsiveinput"
                ).style.opacity = 1;
              }, 500);
            });
          }
        }
      );
    } else {
      const db = getFirestore();
      await updateDoc(doc(db, "teachers", request_data.uid), {
        name,
      });
    }

    document.getElementById("SeeME").style.display = "block";

    document.getElementById("EditME").style.display = "none";
    document.getElementById("hidingMeThis").style.display = "none";
  };

  // var openFile = function (event) {
  //   var input = event.target;
  //   var reader = new FileReader();
  //   reader.onload = fileLoaded;
  //   reader.readAsDataURL(input.files[0]);
  // };

  // var fileLoaded = function (event) {
  //   var dataURL = event.target.result;
  //   var output = document.getElementById("output");
  //   output.src = dataURL;

  //   // Do your other stuff here with dataURL
  //   console.log(">>>>>>>>>", dataURL);
  // };

  const [data_gain, setdata_gain] = useState(false);
  const [request_data, setrequest_data] = useState();

  // useEffect(()=>{
  //   if (props.request!='fail') {

  //   }

  // },[data_gain])

  const re_load = async () => {
    if (props.teacher == "fail") {
      setdata_gain(false);
      await props.gain();
    } else {
      let asd = await props.teacher;
      const teacherData = await asd.find(
        (e) => e.uid == localStorage.getItem("teacher_uid")
      );
      await setrequest_data(teacherData);
      setSelectedTopics(teacherData.topics || []); // Initialize selected topics

      // Fetch Zoom status...
      const data = { email: teacherData.email };
      axios
        .post(
          `https://us-central1-loverclass.cloudfunctions.net/meeting/check_user`,
          data
        )
        .then((res) => {
          setZoomStatus(res.data.status);
          setZoomError(res.data.error);
        })
        .catch((err) => {
          console.log(err);
        });

      setdata_gain(true);
    }
  };


  useEffect(() => {
    fetchTopics();
  }, []);


  useEffect(() => {
    re_load();
  }, [props.teacher]);

  let ChangeMyBack = (file) => {
    // console.log("FILE",file);

    let url = URL.createObjectURL(file);

    // console.log("URL>>>>>",url);
    document.getElementById("imageResponsiveinput").src = url;
    setimage3(file);
  };

  const check_link = () => {
    console.log("Foo cehck");
    const data = {
      email: request_data.email,
      name: request_data.name
    };

    axios
      .post(
        `https://us-central1-loverclass.cloudfunctions.net/meeting/add_user`,
        data
      )
      .then((res) => {
        console.log("Then working>>>>>>>>>>", res.data.error);
        console.log(">>>>>>>RED", res);
        console.log("error>>>>>>", res.data.error);

        if (res.data.error !== undefined) {
          setzoom_conResErr(res.data.error.message);
        }
        document.getElementById("verify").style.display = "block";

        setTimeout(() => {
          document.getElementById("verify").style.display = "none";
          setzoom_conRes(Math.random() * 1000);
        }, 1900);
        console.log(res);
        console.log(res.data.error);

      })
      .catch((err) => {

      });
  };


  const proceed = async () => {
    setErrorText('');

    if (selectedTopics.length === 0) {
      setErrorText('Select at least one Topic');
      return;
    }

    const db = getFirestore();
    try {
      await updateDoc(doc(db, "teachers", request_data.uid), {
        topics: selectedTopics,
      });

      document.getElementById('verify1').style.display = 'block';
      setTimeout(() => {
        document.getElementById('verify1').style.display = 'none';
      }, 1000);
    } catch (error) {
      setErrorText('Failed to update topics. Please try again.');
    }
  };
  const handleTopicSelection = (topicName) => {
    setSelectedTopics(prevTopics => {
      // Create a new array to ensure state updates properly
      if (prevTopics.includes(topicName)) {
        return prevTopics.filter(topic => topic !== topicName);
      } else {
        return [...prevTopics, topicName];
      }
    });
  };

  return localStorage.getItem("teacher_uid") !== null ? (
    <>
      <Sidebar2 />
      <div className="relative md:ml-64 bg-blueGray-100">
        <div id="verify" style={{ display: "none" }} className="loading1">
          <div
            id="verify_hac"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginRight: "20%",
            }}
          >
            {zoom_conResErr == "" ? (
              <>
                <img
                  src={
                    "https://www.compliancegate.com/wp-content/uploads/2021/12/compliance-check.png"
                  }
                  className="verifyImg"
                ></img>
                <p className="popipt">
                  Mail Send Sucessfully.Check Your Inbox!
                </p>
              </>
            ) : (
              <>
                <img
                  src={
                    "https://www.freeiconspng.com/thumbs/warning-icon-png/sign-warning-icon-png-7.png"
                  }
                  className="verifyImg"
                ></img>
                <p className="popipt">
                  {zoom_conResErr !== undefined ? zoom_conResErr : ""}
                </p>
              </>
            )}
          </div>
        </div>



        <div id="verify1" style={{ display: "none" }} className="loading1">
          <div
            id="verify_hac"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginRight: "20%",
            }}
          >

            <img
              src={
                "https://www.compliancegate.com/wp-content/uploads/2021/12/compliance-check.png"
              }
              className="verifyImg"
            ></img>
            <p className="popipt">
              Updated Sucessfully
            </p>

          </div>
        </div>
        {/* <Navbar /> */}
        {/* Header */}
        {console.log("dqdsa", request_data)}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
            <div style={{ height: 38 }}>

            </div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
                Profile
              </h1>
            </div>
          </div>
        </div>
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <div className="flex flex-wrap"></div>

          <div>
            <div class="loading" id="loading" style={{ display: "none" }}>
              Loading&#8230;
            </div>

            <div className="content">
              <div className="main-body">
                <nav aria-label="breadcrumb" className="main-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="index.html">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      User Profile
                    </li>
                  </ol>
                </nav>
                {data_gain && zoom_status !== "" ? (
                  <div className="row gutters-sm">
                    <div className="col-md-4 mb-3">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex flex-column align-items-center text-center">
                            <div class="container1">
                              <div class="avatar-upload">
                                <div class="avatar-edit">
                                  <input
                                    onChange={(e) =>
                                      ChangeMyBack(e.target.files[0])
                                    }
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                  />
                                  <label
                                    id="hidingMeThis"
                                    style={{ display: "none" }}
                                    for="imageUpload"
                                  ></label>
                                </div>
                                <div class="avatar-preview">
                                  <img
                                    style={{
                                      width: 140,
                                      height: 140,
                                      borderRadius: 70,
                                    }}
                                    id="imageResponsiveinput"
                                    src={request_data.pic}
                                  ></img>
                                  {/* {console.log("f>>>>>>>>>>>>>>.",request_data)} */}
                                  <div
                                    style={{ marginTop: 10, fontWeight: "550" }}
                                  >
                                    {progress}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card mb-3" id="SeeME">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Name</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              {request_data.name}{" "}
                            </div>
                          </div>
                          <hr />
                          <br></br>
                          <br></br>

                          <div className="row">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Email</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              {request_data.email}
                            </div>
                          </div>
                          <hr />
                          <div style={{ color: "red" }}>{error}</div>
                          <br></br>

                          <div className="row">
                            <div className="col-sm-12">
                              <button
                                class="btn"
                                style={{
                                  backgroundColor: "#643FFE",
                                  outline: "none",
                                  color: "#fff",
                                }}
                                onClick={() => {
                                  HideMeShowEdit();
                                }}
                              >
                                Edit Profile
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="card"
                        id="EditME"
                        style={{ display: "none" }}
                      >
                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Name</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={request_data.name}
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: 11,
                                  marginTop: 5,
                                }}
                              >
                                {nameValidate}
                              </p>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Email</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={request_data.email}
                                disabled
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: 11,
                                  marginTop: 5,
                                }}
                              >
                                {emailValidate}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-3"></div>
                            <div
                              className="col-sm-9 text-secondary"
                              onClick={() => {
                                UpdateME();
                              }}
                            >
                              {/* <input type="button" class="btn btn-danger" value="Save Changes" /> */}
                              <button
                                class="btn"
                                style={{
                                  backgroundColor: "#643FFE",
                                  outline: "none",
                                  color: "#fff",
                                }}
                                onClick={() => {
                                  UpdateME();
                                }}
                              >
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card mb-3 mt-2">
                        <div className="card-body">
                          <img
                            src="https://www.freepnglogos.com/uploads/zoom-logo-png/zoom-png-logo-download-transparent-20.png"
                            style={{ width: 100, objectFit: "cover" }}
                          />

                          <div className="row mt-2 mb-1">
                            <div className="col-sm-3">
                              <h6 className="mb-0 fw-bold">Status</h6>
                            </div>

                            {/* <div
                                className="col-sm-9 flex flex-row"
                                style={{ color: "gray", fontWeight: "bold" }}
                              >
                                <BsClock
                                  className="ml-1 mr-1 mt-1"
                                  color={"gray"}
                                />
                                Pending
                              </div> */}

                            {zoom_status == "active" ? (
                              <div
                                className="col-sm-9 flex flex-row"
                                style={{ color: "green", fontWeight: "bold" }}
                              >
                                <BsShieldFillCheck
                                  className="ml-1 mr-1 mt-1"
                                  color={"green"}
                                />
                                Connected
                              </div>
                            ) : (
                              <div
                                className="col-sm-9 flex flex-row"
                                style={{ color: "red", fontWeight: "bold" }}
                              >
                                <AiOutlineDisconnect
                                  className="ml-1 mr-1 mt-1"
                                  color={"red"}
                                />
                                Not Connected{" "}
                              </div>
                            )}
                          </div>
                          <hr />

                          <p style={{ fontSize: 14 }}>
                            {zoom_status == "pending" && zoom_Error == undefined
                              ? "Your Zoom Status is Pending At that Time"
                              : zoom_Error !== undefined
                                ? zoom_Error.message
                                : ""}
                          </p>

                          <div className="row position-absolute top-0 right-0 mt-2 mr-1">
                            <div className="col-sm-12">
                              <button
                                class="btn brn-secondary"
                                style={{
                                  backgroundColor: "#2D8CFF",
                                  outline: "none",
                                  color: "#fff",
                                }}
                                onClick={() => {
                                  check_link();
                                }}
                              >
                                Connect
                              </button>
                            </div>
                          </div>
                          <div
                            style={{ marginTop: 20 }}
                            className="
      flex flex-col
      px-4
      sm:px-6
      md:px-8
      lg:px-10
      py-8
      
      
      max-w-full
      align-items-center
      justify-content-start"
                          >
                            <div className="font-medium self-center text-xl sm:text-3xl text-gray-800">
                              Select Topics
                            </div>
                            {/* {console.log("m>>>>>>>>>>>>>>>>>>>>>...",request_data.topics)} */}
                            <div className="mt-4 self-center text-xl sm:text-sm text-gray-800">
                              Update Your Topic Details here
                            </div>
                            <div className="d-flex flex-row flex-wrap align-items-start justify-content-around">
                              <div className="mt-10 ContWidth">

                                <div className="flex flex-row mb-3  flex-wrap justify-content-start align-items-start">
                                  <div style={{ width: "100%" }}>

                                    <div className=" mb-3 flex-wrap justify-content-start align-items-start">
                                      {allTopics.map((topic) => (
                                        <div key={topic.id} style={{ width: "50%" }}>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={selectedTopics.includes(topic.name)}
                                              onChange={() => handleTopicSelection(topic.name)}
                                              id={`topic-${topic.id}`}
                                            />
                                            <label className="form-check-label w-40" htmlFor={`topic-${topic.id}`}>
                                              {topic.name}
                                            </label>
                                          </div>
                                        </div>
                                      ))}
                                    </div>

                                  </div>

                                </div>
                              </div>


                            </div>
                            <div className="flex flex-col " style={{ width: 200 }}>
                              <p style={{ color: 'red' }}>
                                {errorText}
                              </p>
                              <button
                                onClick={() => {
                                  proceed();
                                }}
                                className="
              flex
              mt-2
              items-center
              justify-center
              focus:outline-none
              text-white text-sm
              sm:text-base
              bg-blue-500
              hover:bg-blue-600
              rounded-2xl
              py-2
              w-90
              transition
              duration-150
              ease-in"
                              >
                                <span className="mr-2 uppercase">Update</span>
                                <span>
                                  <svg
                                    className="h-6 w-6"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                  </svg>
                                </span>
                              </button>




                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="loading" id="loading">
                    Loading&#8230;
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    navigate("/Login")
  );
}

const mapStateToProps = (state) => {
  return {
    teacher: state.current_stock,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain: () => dispatch(gain()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileTeacher);
